import {hostGenerator, scheme} from '@afreecatv/domains';

const envConverter = {
  local: 'development',
  dev: 'development',
  qa: 'staging',
  prod: 'production',
};

// 앱 스킴 추가
export const globalAPPScheme = scheme.SERVICE_APP_SCHEME; // sooplive://

const globalDomains = hostGenerator({
  environment: envConverter[process.env.NODE_ENV] || 'development',
  currentProtocol: 'https:', // document ? document.location.protocol : 'https:',
});
export default globalDomains;
